module.exports = __webpack_public_path__ + "static/media/S-1.8dfeb283.mp3";